import { AxiosPromise } from "axios";

import api from "../config/api-config";

export function getUserPopulateData(): AxiosPromise {
  return api.get("v1/auth");
}

export function getDailyProcessLog(): AxiosPromise {
  return api.get("v1/dailyProcessLog");
}

export function postLogFront(obj: any): AxiosPromise {
  return api.post("v1/logs", obj, {});
}

export default {
  getUserPopulateData,
  postLogFront,
  getDailyProcessLog,
};
